//xport const DevelopmentUri = `https://localhost:44375`; //Local 
//export const DevelopmentUri = `http://103.107.184.31:9020`; // Server
export const DevelopmentUri = `http://103.107.184.30:9020`; // Server